import type { CompetitorRelationshipKind } from '@/services/data/CompetitorService';

/**
 * What a `competitors` row means to a workspace, resolved from its business
 * type. Mirrors the labels ICP_BRANDS_COPY assigns per type in
 * DiscoverContextPanel — a professional-services rival ("Competitors"),
 * a creator/company rival ("Your Competitors" / "Competitors") and a
 * personal-brand thought leader are all real competitive intel; an
 * ecommerce account's "Followed Brands" are aspirational, not necessarily
 * rivals; an agency's "Client Accounts" aren't competitive intel at all.
 */
const BUSINESS_TYPE_TO_RELATIONSHIP_KIND: Record<string, CompetitorRelationshipKind> = {
  service: 'competitor',
  creator: 'competitor',
  company: 'competitor',
  personal_brand: 'competitor',
  ecommerce: 'inspiration',
  agency: 'client_account',
};

export function businessTypeToRelationshipKind(
  businessType: string | null | undefined,
): CompetitorRelationshipKind {
  return BUSINESS_TYPE_TO_RELATIONSHIP_KIND[businessType ?? ''] ?? 'competitor';
}
